export interface IUsers {
  uuid?: string;
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  password?: string;
  confirm_password?: string;
  device_name: string;
  roles: [number];
  permissions?: [number];
  active: string;
  role?:string;
}


export const UsersInitValues: IUsers = {
  username: '',
  firstname: '',
  lastname: '',
  email: '',
  password: '',
  confirm_password: '',
  device_name: '',
  roles: [1],
  active: 'true',
}

